import { countries } from '@/cip/widgets/CountryFlag';

export const LargerFlagCell = ({ alpha3 }: { alpha3?: string }) => {
    if (!alpha3) {
        return null;
    }

    const country = countries.find((c) => c.alpha3 === alpha3);

    if (!country) {
        return <span>{alpha3}</span>;
    }

    return (
        <div className="flex items-center gap-2">
            <div
                style={{
                    width: '28px',
                    height: '20px',
                    backgroundImage: `url(https://flags.ndvrit.com/${country.alpha2.toLowerCase()}.png)`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    flexShrink: 0,
                }}
            />
            <span>{alpha3}</span>
        </div>
    );
};
